import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import BASE_URL from "../../../baseUrl";

const Categories = ({type}) => {
  const [data, setData] = useState([]);
 
  const [flag, setFlag] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get-propertycount-by-category/${type === undefined?"all":type}`)
      .then((res) => {
        setFlag(true);
        setData(res.data);
      });
  }, []);

  return (
    <div className="section py-4">
      <div className="container">
        <div className="section-title-wrap section-header">
          <h5 className="custom-primary">{t("Category")}</h5>
        </div>
        <div className="row">
          {data && data?.length === 0 && flag ? (
            <h5>No Category</h5>
          ) : data && data?.length === 0 && flag === false ? (
            <h5>Loading...</h5>
          ) : (
            Array.isArray(data) && data?.map((item, i) => (
              <div key={i} className="col-lg-4 col-md-6">
                <div className="acr-category">
                  <div className="acr-category-thumb">
                    <i>
                      <img
                        src={`${item.icon}`}
                        alt="CategoryIcon"
                        style={{
                          borderRadius: "inherit",
                          height: "inherit",
                          width: "inherit",
                        }}
                      />
                    </i>

                    <Link   to={`/property/${item.name.replace(/\//g, '&')}/${type ? type : 'all'}`}>
                      <img
                        src={`${item.img}`}
                        style={{
                          width: "-webkit-fill-available",
                          height: "300px",
                          objectFit: "cover",
                        }}
                        alt="category"
                      />
                    </Link>
                    <Link  to={`/property/${item.name.replace(/\//g, '&')}/${type ? type : 'all'}`}>
                      <div className="acr-category-body">
                        <h5>
                          {" "}
                          {t(item.name)}
                        </h5>
                        <span>{item.count} Listings</span>
                      </div>
                    </Link>{" "}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Categories;
